import http from '@/libs/http'

export default {
  find(id) {
    return http.get(`/cms/token/${id}`).then(result => result.data)
  },
  listAll() {
    return http.get('/cms/tokens').then(result => result.data)
  },
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    return http.get('/cms/tokens', { params }).then(result => result.data)
  },
  create(model) {
    return http.post('/cms/tokens', this._cleanCreate(model)).then(result => result.data).catch(error => error)
  },
  update(model) {
    return http.put(`/cms/token/${model.id}`, this._clean(model)).then(result => result.data)
  },
  updateActivated(id, activated) {
    return http.put(`/cms/token/activated/${id}`, { activated }).then(result => result.data)
  },
  delete(id) {
    return http.delete(`/cms/token/${id}`).then(result => result.data)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    delete m.isClone
    return m
  },
  _cleanCreate(model) {
    const m = Object.assign({}, model)
    delete m.id
    delete m.isClone
    return m
  },
  generate() {
    return http.get('/cms/token/generate').then(result => result.data)
  }
}
